export default __webpack_public_path__ + "static/media/IconHand.81652712.svg";